export default {
  allowAlignment: true,
  allowSubheading: false,
  allowVideoFile: true,
  autoCenter: ['initialHeading', 'image', 'button']
};